import moment from 'moment'

const SignatureRequestValidator = (t) => {
  let validateDate = false
  moment.locale('es')
  let regexs = {
    nameRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,./;:¿?¡!()"'_-]+$/),
    nameSignatureRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.@/;:¿?¡!()"'_-]+$/),
    descriptionRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.@/;:¿?¡!()"'_\-\n]+$/),
    commentsRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.@/;:¿?¡!()"'_-]+$/),
    eventRegex: new RegExp(/^[A-Za-z0-9 ]+/),
    emailRegex: new RegExp(/^[a-zA-ZñÑ0-9._-]+@([a-zA-Z0-9._-]+\.)+[\w-]{2,}$/)
  }

  let validators = {
    nameValidator: (value) => {
      if (value) {
        if (value.length >= 100) {
          return t('signature.request.nameLengthValidator')
        }
        if (value.length >= 0) {
          return (regexs.nameRegex.test(value) ? "" : t('signature.request.nameValidator'))
        }
      }
    },
    nameSignatureValidator: (value) => {
      if (value === "" && value === undefined) {
        return (regexs.nameSignatureRegex.test(value) ? "" : t('signature.request.descriptionValidator'))
      }
      else {
        return t('signature.request.emailValidatorNull')
      }
    },
    descriptionValidator: (value) => {
      if (value.length > 0) {
        return (regexs.descriptionRegex.test(value) ? "" : t('signature.request.descriptionValidator'))
      }
    },
    commentsValidator: (value) => {
      if (value.length > 0) {
        return (regexs.commentsRegex.test(value) ? "" : t('signature.request.commentsValidator'))
      }
    },
    limitDateValidator: (value) => {
      const now = moment().add(1, 'days').startOf('day').toDate()
      var toDay = moment()
      if (value < now) {
        validateDate = true
      } else {
        validateDate = false
      }
      if (!value || validateDate || toDay.diff(value, 'days') <= -60) {
        return t('signature.request.limitDateValidator')
      } else {
        return ''
      }
    },
    emailValidator: (value) => {
      if (value !== '' && value !== undefined) {
        if (value.length > 0) {
          return (regexs.emailRegex.test(value) ? "" : t('signature.request.emailValidator'))
        }
      } else {
        return t('signature.request.emailValidatorNull')
      }
    }
  }

  return validators
}

export { SignatureRequestValidator as default }
